// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mylearningpaths {
    inline-size: 100%;
    block-size: 91vh;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: hwb(220 92% 0%);
    box-sizing: border-box;
}
.students-flex {
    inline-size: 100%;
}
.courses {
    display: flex;
    flex-wrap: wrap;
    margin-block-start: 10px;
}

.courses a {
    text-decoration: none;
    transition: color 0.3s ease-in-out, margin-left 0.3s ease-in-out;
    margin-inline-start: 40px;
}

.active,
.favorite,
.launched {
    font-weight: 400;
    font-size: 1rem;
    color: #000000;
}

.active-link h1,
.favorite-link h1,
.launched-link h1 {
    border-block-end: 4px solid #5483B3;
    color: #000000;
    padding-block-end: 10px;
    margin-inline-start: 4px;
}

.courseslist-courses,
.myactive-projectses-dashboard {
    inline-size: 750px;
    margin-inline-end: 20px;
    border-radius: 20px;
    margin-block-start: 20px;
}

.courseslistp-myactive-courses {
    font-size: 1.2rem;
    color: rgb(0, 0, 0);
    font-weight: 400;
}

.courseslist-p {
    font-size: 1.2rem;
    font-weight: 700;
    color: red;
}

.courseslist-myactive-courses,
.courseslist-completed-courses,
.courseslist-launched-courses {
    padding-block-end: 4px;
    margin-inline-start: 43px;
}

.myactive,
.myfavorite,
.mylaunched, 
.courseslist {
    font-weight: 700;
    font-size: 36px;
    color: #000000;
}

.courseslist-course-row {
    display: flex;
    justify-content: start;
    margin-block-end: 10px;
}

.courseslist-course-box {
    padding: 10px 20px 20px 20px;
    margin: 20px 40px 0px 0px;
    inline-size: 100%;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 20px 40px rgba(255, 254, 254, 0.2), 0 0 20px rgba(0, 0, 0, 0.1), inset 0 0 20px rgba(255, 255, 255, 0.5);
}

.spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    block-size: 100vh;
}

.spinner {
    inline-size: 50px;
    block-size: 50px;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-block-start: 5px solid #043885;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media (max-width: 480px) {
    .students-courses {
        block-size: 636px;
        padding-block-end: 20px;
    }
    .courses {
        margin-block-end: 20px;
        margin-inline-end: 20px;
    }
    .courses a {
        margin-inline-start: 10px;
        margin-inline-end: 20px;
    }
    .active,
    .favorite,
    .launched {
        font-weight: 700;
    }
    .active-link h1,
    .favorite-link h1,
    .launched-link h1 {
        padding-block-end: 10px;
    }
    .courseslist-courses,
    .myactive-projectses-dashboard {
        inline-size: auto;
        margin-inline-end: 20px;
    }
    .courseslist-myactive-courses,
    .courseslist-completed-courses,
    .courseslist-launched-courses {
        margin-inline-start: 10px;
        margin-inline-end: 10px;
    }
    .myactive,
    .myfavorite,
    .mylaunched {
        font-size: 30px;
    }
    .courseslist-course-row {
        flex-direction: column;
        justify-content: start;
        margin-block-end: 20px;
    }
}


/* Tablet Styling */

@media (min-width: 481px) and (max-width: 1279px){
    .courseslist-courses,
    .myactive-projectses-dashboard {
        inline-size: auto;
        margin: 10px 40px 0px 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/learnersDashboard/courses.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,gEAAgE;IAChE,yBAAyB;AAC7B;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;;IAGI,mCAAmC;IACnC,cAAc;IACd,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;;;IAGI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;;;IAII,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,sHAAsH;AAC1H;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;;;QAGI,gBAAgB;IACpB;IACA;;;QAGI,uBAAuB;IAC3B;IACA;;QAEI,iBAAiB;QACjB,uBAAuB;IAC3B;IACA;;;QAGI,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;;;QAGI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;;AAGA,mBAAmB;;AAEnB;IACI;;QAEI,iBAAiB;QACjB,yBAAyB;IAC7B;AACJ","sourcesContent":[".mylearningpaths {\n    inline-size: 100%;\n    block-size: 91vh;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background-color: hwb(220 92% 0%);\n    box-sizing: border-box;\n}\n.students-flex {\n    inline-size: 100%;\n}\n.courses {\n    display: flex;\n    flex-wrap: wrap;\n    margin-block-start: 10px;\n}\n\n.courses a {\n    text-decoration: none;\n    transition: color 0.3s ease-in-out, margin-left 0.3s ease-in-out;\n    margin-inline-start: 40px;\n}\n\n.active,\n.favorite,\n.launched {\n    font-weight: 400;\n    font-size: 1rem;\n    color: #000000;\n}\n\n.active-link h1,\n.favorite-link h1,\n.launched-link h1 {\n    border-block-end: 4px solid #5483B3;\n    color: #000000;\n    padding-block-end: 10px;\n    margin-inline-start: 4px;\n}\n\n.courseslist-courses,\n.myactive-projectses-dashboard {\n    inline-size: 750px;\n    margin-inline-end: 20px;\n    border-radius: 20px;\n    margin-block-start: 20px;\n}\n\n.courseslistp-myactive-courses {\n    font-size: 1.2rem;\n    color: rgb(0, 0, 0);\n    font-weight: 400;\n}\n\n.courseslist-p {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: red;\n}\n\n.courseslist-myactive-courses,\n.courseslist-completed-courses,\n.courseslist-launched-courses {\n    padding-block-end: 4px;\n    margin-inline-start: 43px;\n}\n\n.myactive,\n.myfavorite,\n.mylaunched, \n.courseslist {\n    font-weight: 700;\n    font-size: 36px;\n    color: #000000;\n}\n\n.courseslist-course-row {\n    display: flex;\n    justify-content: start;\n    margin-block-end: 10px;\n}\n\n.courseslist-course-box {\n    padding: 10px 20px 20px 20px;\n    margin: 20px 40px 0px 0px;\n    inline-size: 100%;\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 20px 40px rgba(255, 254, 254, 0.2), 0 0 20px rgba(0, 0, 0, 0.1), inset 0 0 20px rgba(255, 255, 255, 0.5);\n}\n\n.spinner-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    block-size: 100vh;\n}\n\n.spinner {\n    inline-size: 50px;\n    block-size: 50px;\n    border: 5px solid rgba(0, 0, 0, 0.1);\n    border-block-start: 5px solid #043885;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@media (max-width: 480px) {\n    .students-courses {\n        block-size: 636px;\n        padding-block-end: 20px;\n    }\n    .courses {\n        margin-block-end: 20px;\n        margin-inline-end: 20px;\n    }\n    .courses a {\n        margin-inline-start: 10px;\n        margin-inline-end: 20px;\n    }\n    .active,\n    .favorite,\n    .launched {\n        font-weight: 700;\n    }\n    .active-link h1,\n    .favorite-link h1,\n    .launched-link h1 {\n        padding-block-end: 10px;\n    }\n    .courseslist-courses,\n    .myactive-projectses-dashboard {\n        inline-size: auto;\n        margin-inline-end: 20px;\n    }\n    .courseslist-myactive-courses,\n    .courseslist-completed-courses,\n    .courseslist-launched-courses {\n        margin-inline-start: 10px;\n        margin-inline-end: 10px;\n    }\n    .myactive,\n    .myfavorite,\n    .mylaunched {\n        font-size: 30px;\n    }\n    .courseslist-course-row {\n        flex-direction: column;\n        justify-content: start;\n        margin-block-end: 20px;\n    }\n}\n\n\n/* Tablet Styling */\n\n@media (min-width: 481px) and (max-width: 1279px){\n    .courseslist-courses,\n    .myactive-projectses-dashboard {\n        inline-size: auto;\n        margin: 10px 40px 0px 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
